<script lang="ts" setup>
import { computed } from 'vue';

// Props
// ===================
const props = defineProps<{
  isOpen: boolean;
  isLoading: boolean;
  copilotName: string;
  jobCount: number;
}>();

// Emits
// ===================
const emit = defineEmits(['delete', 'cancel', 'after-leave']);

// Computed Properties
// ===================
const isModalOpen = computed(() => props.isOpen);
const recruiterName = computed(() => props.copilotName);

const confirmationText = computed(() => {
  const jobCount = props.jobCount;
  const hasJobs = jobCount > 0;

  if (hasJobs) {
    const jobCountText = jobCount === 1 ? 'job' : 'jobs';
    // eslint-disable-next-line max-len
    return `is currently assigned to ${jobCount} ${jobCountText}. Deleting this AI recruiter will keep the settings on those jobs (they'll continue to work as-is) but this recruiter will be permanently removed from your team.`;
  } else {
    return `will be permanently removed from your team.`;
  }
});
</script>

<template>
  <v-dialog
    :model-value="isModalOpen"
    max-width="512px"
    persistent
    @after-leave="emit('after-leave')"
  >
    <div class="rounded-lg bg-white p-6 text-base shadow-md">
      <!-- Header -->
      <div class="mb-2 font-serif text-2xl font-bold text-shade-900">Are you sure?</div>

      <!-- Content -->
      <div class="text-shade-900">
        <span class="font-bold"> {{ recruiterName }}</span>
        {{ confirmationText }}
      </div>

      <!-- Actions: stack on mobile so a long "Delete {name}" label can't overflow -->
      <div class="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end sm:gap-0">
        <v-btn
          :ripple="false"
          class="modal-button-secondary"
          variant="flat"
          :loading="isLoading"
          @click.prevent="$emit('cancel')"
          >Cancel</v-btn
        >
        <v-btn
          :ripple="false"
          class="modal-button-primary sm:ml-4"
          :loading="isLoading"
          variant="flat"
          @click.prevent="$emit('delete')"
          >Delete {{ recruiterName }}</v-btn
        >
      </div>
    </div>
  </v-dialog>
</template>
